import styled from 'styled-components';
import DetailFailedSvg from '../../assets/mytrips/hotel-detail-failed.svg';

const DetailFailedIcon = styled(DetailFailedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '46.5rem'};
  height: ${props => props.height || '14.1rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DetailFailedIcon;
